/**
 * Compact one-line Meal Map week label: "Jay's week of Sep 6", with the year
 * only when it isn't this year. Used by the landscape-phone web header and
 * the native landscape week grid.
 */
export const compactWeekLabel = (date, firstName) => {
    const opts = date.getFullYear() === new Date().getFullYear()
        ? { month: 'short', day: 'numeric' }
        : { month: 'short', day: 'numeric', year: 'numeric' };
    const who = firstName ? `${firstName}'s week` : 'Week';
    return `${who} of ${date.toLocaleString('en-US', opts)}`;
};
